import { render } from "./hotels-table.vue?vue&type=template&id=064b5218"
import script from "./hotels-table.vue?vue&type=script&lang=js"
export * from "./hotels-table.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__